var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isVisible,
          expression: "isVisible"
        }
      ],
      class: [
        "wrapper",
        "wrap-left",
        "h-100",
        { "open-modal-left": _vm.isOpen }
      ]
    },
    [
      _c("div", { staticClass: "modalBody bg-white w-100 h-100" }, [
        _c("div", { staticClass: "modalHeader" }, [
          _c("div", { staticClass: "title-section" }, [
            _vm._v(
              _vm._s(
                _vm.$translate(
                  "ETCeresCoconut::Template.etcNewsletterSectionTitel"
                )
              )
            )
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "close-modal-button",
            on: { click: _vm.startClose }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modalContent" },
          [
            _c("ul", { staticClass: "newsletter-bullet-points" }, [
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "ETCeresCoconut::Template.etcNewsletterBulletPoint1"
                    )
                  )
                }
              }),
              _vm._v(" "),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "ETCeresCoconut::Template.etcNewsletterBulletPoint2"
                    )
                  )
                }
              }),
              _vm._v(" "),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "ETCeresCoconut::Template.etcNewsletterBulletPoint3"
                    )
                  )
                }
              }),
              _vm._v(" "),
              _c("li", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$translate(
                      "ETCeresCoconut::Template.etcNewsletterBulletPoint4"
                    )
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c("h4", { staticClass: "leftmodal-header" }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$translate(
                      "ETCeresCoconut::Template.etcNewsletterAnmeldungText"
                    )
                  ) +
                  "\n      "
              )
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "lazy-hydrate",
              { attrs: { "when-idle": "" } },
              [
                _c("newsletter-input", {
                  attrs: { "email-folder": _vm.emailFolderId }
                })
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "modalFooter" }, [
          _c("div", { staticClass: "small mt-2" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$translate(
                    "ETCeresCoconut::Template.etcNewsletterInformationText"
                  )
                ) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "small mt-2" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$translate("Ceres::Template.newsletterIsRequiredFootnote")
                ) +
                "\n        " +
                _vm._s(_vm.$translate("Ceres::Template.newsletterIsRequired")) +
                "\n      "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "overlay", on: { click: _vm.startClose } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }